import React from "react";

const Java_Lambda = () => {
  return (
    <div>
      <h1>Java Lambda</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Lambda in Java.</p>
    </div>
  );
};

export default Java_Lambda;
